import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { useMemo, useState } from "react"
import ModalDelete from "../../components/ModalDelete"
import { ScrollLayout } from "../../components/ScrollLayout"
import type { Path } from "../../types"
import { initialValuesPath, validationSchemaPath } from "./PathCommon"
import { useDeletePath, usePartialUpdatePath, usePath } from "../../hooks/paths"
import PathForm from "./PathForm"
import PathEditorForm from "./PathEditorForm"

export default function PathUpdate() {
  const updatePath = usePartialUpdatePath()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: path } = usePath(Number(id))

  const deletePath = useDeletePath()

  const [modalStateDeletePath, modalActionsDeletePath] = useModalTrigger()

  const initialValues = useMemo(() => initialValuesPath(path), [path])
  const validationSchema = useMemo(() => validationSchemaPath(), [])

  const [activeTab, setActiveTab] = useState("dettaglio")

  useBreadcrumbs([{ label: "Percorsi", href: "/paths/paths" }, { label: "Dettaglio Percorso" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{path?.title}</H1>
          {activeTab === "dettaglio" && (
            <Button
              size="md"
              variant="danger"
              title="Elimina"
              leadingIcon="delete"
              onClick={() => {
                modalActionsDeletePath.open()
              }}
            />
          )}
        </Flex>
        <ScrollLayout.Tabs
          className="mt-6"
          onTabChange={(tab) => {
            setActiveTab(tab)
          }}
          initialTab="dettaglio"
        >
          <ScrollLayout.Tab id="dettaglio" label="Dettaglio" key={"dettaglio"}>
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                return updatePath.mutateAsync(values as Path).then(() => {
                  navigate(`/paths/paths`)
                })
              }}
            >
              {({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                    <PathForm />
                  </Container>
                  <BottomFormFixed url="/paths/paths" />
                </form>
              )}
            </Formik>
          </ScrollLayout.Tab>
          <ScrollLayout.Tab id="contenuti" label="Contenuti" key={"contenuti"}>
            <Container fluid className="mt-6">
              <PathEditorForm
                path={path}
                onSave={(d) => {
                  updatePath.mutate({
                    id: Number(id),
                    story: d,
                  })
                }}
                currentValue={path?.story || []}
              />
            </Container>
          </ScrollLayout.Tab>
        </ScrollLayout.Tabs>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeletePath.isOpen}
        onClose={modalActionsDeletePath.close}
        onDelete={() => {
          return deletePath.mutateAsync(path?.id).then(() => {
            navigate(`/paths/paths`)
          })
        }}
        message="Sei sicuro di voler eliminare il percorso?"
        title="Elimina Percorso"
      />
    </Layout>
  )
}
